import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import Title from "../../../Title";
import { defaultPropObject } from "../../../constants";
import { CloseLinear, Search } from "../../../icons";
import { InputBase } from "../../../internal/InputBase";
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import styles from './Dropdown.css';
var cx = classNames.bind(styles);
export var Dropdown = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      mobile = _ref.mobile,
      mobilePopover = _ref.mobilePopover,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onClose = _ref.onClose,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      value = _ref.value,
      namespace = _ref.namespace;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'dropdown'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root', _defineProperty({}, "size_".concat(size), size), classes.dropdown)
  }, getTestId()), mobile && !mobilePopover && /*#__PURE__*/React.createElement("div", _extends({
    role: "button",
    onClick: onClose,
    className: cx('overlay', classes.dropdownOverlay),
    "aria-hidden": "true"
  }, getTestId('overlay'))), /*#__PURE__*/React.createElement("div", {
    className: cx('inner', {
      popover: mobilePopover && mobile
    }, classes.dropdownInner)
  }, mobile && /*#__PURE__*/React.createElement("div", {
    className: cx('header', classes.dropdownHeader)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('title', classes.dropdownTitle)
  }, /*#__PURE__*/React.createElement(Title, {
    as: "div",
    level: 5
  }, label)), /*#__PURE__*/React.createElement("button", _extends({
    className: cx('close', classes.dropdownClose),
    type: "button",
    onClick: onClose
  }, getTestId('buttonClose')), /*#__PURE__*/React.createElement(CloseLinear, null)), /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', classes.dropdownInputWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('icon', classes.dropdownInputIcon)
  }, /*#__PURE__*/React.createElement(Search, null)), /*#__PURE__*/React.createElement(InputBase, _extends({
    autoFocus: true,
    className: cx('input_component', classes.dropdownInput),
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    value: value,
    ref: ref
  }, getTestId('input'))))), /*#__PURE__*/React.createElement("div", {
    className: cx('list', classes.dropdownList)
  }, children)));
});